export enum AppEnvironmentEnum {
  Localhost = "Localhost",
  Develop = "Develop",
  Test = "Test",
  Production = "Production",
}
